import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { FormContainer, Treturn, useFetch } from "@4uhub/lib4uhub";

import {
  createScheduleNewCheckIn,
  getScheduleNewCheckInById,
  updateScheduleNewCheckInById,
} from "../../../../../../../services/scheduleNewCheckIn.service";
import {
  TScheduleNewCheckInForm,
  scheduleNewCheckInSchema,
} from "./ScheduleNewCheckInSchema";
import ScheduleNewCheckInFields from "./ScheduleNewCheckInFields";
import { formToRequest, responseToForm } from "./ScheduleNewCheckInMapper";
import { ETasyScheduleTypeCode } from "../../../../../../Schedule/model";

const translationPath = "page.settings.schedule.scheduleNewCheckIn.";

const ScheduleNewCheckIn = () => {
  const { t } = useTranslation();

  const { sendRequest: save, loading: sLoading } = useFetch(
    createScheduleNewCheckIn
  );

  const { sendRequest: update, loading: uLoading } = useFetch(
    updateScheduleNewCheckInById
  );

  const { sendRequest: get, loading: gLoading } = useFetch(
    getScheduleNewCheckInById
  );

  const handleSave = (v: TScheduleNewCheckInForm) => save(formToRequest(v));

  const updateHandler = (v: TScheduleNewCheckInForm, id: string) =>
    update({ item: formToRequest({ ...v, id }), id });

  const scheduleTypeName = useCallback(
    (code: string) =>
      t(
        translationPath +
          (code === ETasyScheduleTypeCode.EXAM ? "exam" : "consultation"),
      ),
    [t]
  );

  const handleGet = useCallback(
    async (id: string): Promise<Treturn<TScheduleNewCheckInForm>> => {
      const { data } = await get(id);
      if (data) {
        return {
          data: responseToForm(data, scheduleTypeName),
          success: true,
        };
      }
      return {
        data: null,
        success: false,
      };
    },
    [get, scheduleTypeName]
  );

  const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TScheduleNewCheckInForm>
      saveFunction={handleSave}
      updateFunction={updateHandler}
      getFunction={handleGet}
      loading={loading}
      title={t(translationPath + "schedule_new_check_in") || "Regra de Check-in"}
      schema={scheduleNewCheckInSchema}
      subtitle={t(translationPath + "new_schedule_new_check_in") || "Nova Regra"}
      subtitleWatchField={"tasyScheduleType.name"}
      fields={() => <ScheduleNewCheckInFields />}
    />
  );
};

export default ScheduleNewCheckIn;
